// Russian translations for UI texts
const ru = {
  appName: 'ProTicket',
  loading: 'Загрузка...',
  error: 'Ошибка',
  rowsPerPage: 'Строк на странице:',
  rows: 'Строк',
  of: 'из',
  id: 'ID',
  title: 'Заголовок',
  project: 'Проект',
  author: 'Автор',
  status: 'Статус',
  createdAt: 'Создано',
  plannedEndDate: 'План. дата решения',
  actions: 'Действия',
  ticket: 'Заявка',
  addComment: 'Добавить комментарий',
  comments: 'Комментарии',
  noComments: 'Нет событий',
  unknown: 'Неизвестно',
  attachFile: 'Прикрепить файл',
  create: 'Создать',
  comment: 'Комментарий',
  dueDate: 'Срок',
  attachment: 'Вложение',
  description: 'Описание',
  archive: 'Архив',
  active: 'Активные',
  new: 'Новый',
  open: 'Открыто',
  inProgress: 'В работе',
  resolved: 'Решен',
  closed: 'Закрыто',
  medium: 'Средний',
  high: 'Высокий',
  low: 'Низкий',
  all: 'Все',
  // В начале файла уже есть plannedEndDate со значением 'План. дата решения'.
  // Это значение используется в интерфейсе для краткого отображения
  writeComment: 'Написать комментарий',
  delete: 'Удалить',
  edit: 'Редактировать',
  close: 'Закрыть',
  save: 'Сохранить',
  cancel: 'Отмена',
  filter: 'Фильтр',
  search: 'Поиск',
  user: 'Пользователь',
  password: 'Пароль',
  login: 'Войти',
  logout: 'Выйти',
  register: 'Регистрация',
  confirm: 'Подтвердить',
  profile: 'Профиль',
  settings: 'Настройки',
  noData: 'Нет данных',
  showMore: 'Показать больше',
  back: 'Назад',
  home: 'Главная',
  tickets: 'Заявки',
  file: 'Файл',
  files: 'Файлы',
  date: 'Дата',
  time: 'Время',
  users: 'Пользователи',
  role: 'Роль',
  organization: 'Организация',
  email: 'Email',
  phone: 'Телефон',
  name: 'Имя',
  surname: 'Фамилия',
  download: 'Скачать',
  add: 'Добавить',
  change: 'Изменить',
  send: 'Отправить',
  please: 'Пожалуйста',
  enter: 'Введите',
  select: 'Выбрать',
  no: 'Нет',
  yes: 'Да',
  areYouSure: 'Вы уверены?',
  upload: 'Загрузить',
  show: 'Показать',
  hide: 'Скрыть',
  showAll: 'Показать все',
  hideAll: 'Скрыть все',
  moreDetails: 'Подробнее',
  next: 'Далее',
  previous: 'Назад',
  page: 'Страница',
  pages: 'Страницы',
  first: 'Первая',
  last: 'Последняя',
  total: 'Всего',
  items: 'Элементов',
  empty: 'Пусто',
  noResults: 'Нет результатов',
  projects: 'Проекты',
  createProject: 'Новый проект',
  now: 'Сейчас',
  editProject: 'Редактировать проект',
  projectName: 'Название проекта',
  ticketPrefix: 'Префикс номера тикета',
  deleteProject: 'Удалить проект?',
  visibleToAllUsers: 'Заявки видят все пользователи проекта',
  deleteTicket: 'Удалить заявку?',
  confirmDeleteTicket: 'Вы действительно хотите удалить эту заявку? Это действие нельзя отменить.',
};

export default ru;
